const ScienceAndTechnologydata = [
    {
        id : "1",
        schemeName: "Self Employment Scheme for Rehabilitation of Manual Scavengers.",
        discription:"Self Employment Scheme for Rehabilitation of Manual Scavengers (SRMS) provides financial benefits to the manual scavengers for their rehabilitation in alternative occupations. This is a Centrally funded scheme provided by the Ministry of Social Justice and Empowerment. Manual Scavengers and their dependents are eligible to avail the Scheme. ",
        launchDate: "Year 2007",
        AnualFund: "12345"

    },
   {id : "2",
    schemeName: "Deendayal Disabled Rehabilitation Scheme",
    discription:"Original form was the 1999 scheme to Promote Voluntary Action for Persons with Disabilities, with the aim of implementing Persons With Disabilities Act, 1995. DDRS to create an enabling environment to ensure equal opportunities, equity, social justice and empowerment of persons with disabilities  ",
    launchDate: "Year 2003",
    AnualFund: "12345"},

]

export default ScienceAndTechnologydata;